import { useMemo } from 'react';

export const useValorTotal = (
  areaInicialTerreno: number,
  valorUnitarioSaneado: number
): number => {
  return useMemo(() => {
    return areaInicialTerreno * valorUnitarioSaneado;
  }, [areaInicialTerreno, valorUnitarioSaneado]);
};
